
import { CartPage } from "./products/cart/views/cart-page";

(function($){
	var initializeCartPage = function(){
        $('.cart-wrap').each(function(){

            var cart = window.cart;
            var cartPage = new CartPage({model: cart, el: $(this)});
            cartPage.render();
        });
    }
	$(document).ready(function(){
        
        if ( typeof window.cart !== 'undefined') {
            initializeCartPage();
        } else {
            $( window ).on( 'cart-ready', initializeCartPage );
        }
        

    });
})(jQuery);